module.exports = "<div class=\"section-header-icon\"></div>\n<div class=\"section-header-text\" ng-transclude></div>\n";